import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import About from '@/components/About'
import Projects from '@/components/Projects'
import Contact from '@/components/Contact'
import {vueAccordion} from 'vue-accordion'
import Icon from 'vue-awesome/components/Icon'

Vue.component('vue-accordion', vueAccordion)
Vue.component('v-icon', Icon)
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        auth: true,
        title: 'Home'
      }
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/projects',
      name: 'Projects',
      component: Projects
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    }
  ],
})


// WEBPACK FOOTER //
// ./src/router/index.js